import { Button } from '@ps-design-system/components/Button';
import {
  MarketingCard,
  MarketingCardContent,
  MarketingCardFooter,
  MarketingCardHeader,
  MarketingCardTitle
} from '@ps-design-system/components/cards/MarketingCard';
import ArrowRightIcon from '@ps-design-system/icons/ArrowStylizedFilled/ArrowStylizedFilled16';
import EnvelopeIcon from '@ps-design-system/icons/Envelope/Envelope24';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const InviteToBookCard = ({ bookingId, router, pid }) => {
  const handleCtaClick = () => {
    analyticsIntegrations.publicAttendee('attendee details: view and share', {
      label: bookingId,
      origin: 'booking'
    });

    router.push(`/invite/router/${pid}`);
  };

  return (
    <MarketingCard className="invite-to-book-card">
      <MarketingCardHeader>
        <EnvelopeIcon />
        <MarketingCardTitle>
          <FormattedMessage
            id="invite_to_book_card.invite_your_guests"
            defaultMessage="Invite your guests"
          />
        </MarketingCardTitle>
      </MarketingCardHeader>

      <MarketingCardContent>
        <FormattedMessage
          id="invite_to_book_card.send_invites"
          defaultMessage="Send invites to easily communicate event hours, allow guests to RSVP, receive parking information and more."
        />
      </MarketingCardContent>

      <MarketingCardFooter>
        <Button
          variant="text-only"
          appearance="purple"
          suffix={<ArrowRightIcon />}
          onClick={handleCtaClick}
        >
          <FormattedMessage
            id="invite_to_book_card.invite"
            defaultMessage="Invite"
          />
        </Button>
      </MarketingCardFooter>
    </MarketingCard>
  );
};
